import React from 'react';
import GraphicsUpload from '../components/GraphicsUpload/GraphicsUpload';
import GraphicsUploadConsent from '../components/GraphicUploadConsent/GraphicUploadConsent';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';

interface Props {
    onSubmit: () => void;
    customerId: number | null;
    guestId: number | null;
}

const GraphicUploadContainer: React.FC<Props> = ({
    onSubmit,
    customerId,
    guestId,
}) => {
    const { accepted } = useTypedSelector(
        (state) => state.graphicUpload.consent
    );

    return (
        <>
            {accepted && (
                <GraphicsUpload
                    onSubmit={onSubmit}
                    customerId={customerId}
                    guestId={guestId}
                />
            )}
            {!accepted && <GraphicsUploadConsent />}
        </>
    );
};

export default GraphicUploadContainer;
